import ToolsChart from './ToolsChart'
import Yarns from './Yarns'
import NavBar from './NavBar'
import Footer from './Footer'

import HomePage from '../pages/HomePage'
import CreateIntarsia from '../pages/CreateIntarsia'
import ShowColorChart from '../pages/ShowColorChart'
import ColorCharts from '../pages/ColorCharts'

import { Outlet } from 'react-router-dom'
import { Routes, Route } from 'react-router-dom'

function Router() {
  return (
    <>
      <NavBar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/tools" element={<ToolsChart />} />
        <Route path="/yarns" element={<Yarns />} />
        <Route path="/color-charts" element={<ColorCharts />} />
        <Route path="/color-charts/new" element={<CreateIntarsia />} />
        <Route path="/color-charts/:id" element={<ShowColorChart />} />
      </Routes>
      <Outlet />
      <Footer />
    </>
  );
}

export default Router
